import { OPEN_METEO_FORECAST } from "../shared/sources";
import { windFieldFromOpenMeteo, windFieldQuery, type WindField } from "../shared/wind-field";
import type { BBox } from "../shared/types";

/**
 * Browser → Open-Meteo POST (CORS allows it). GET of a dense viewport grid is 414.
 */
export async function loadOpenMeteoWindField(spec: { box: BBox; nx: number; ny: number }): Promise<WindField | null> {
  try {
    const res = await fetch(OPEN_METEO_FORECAST, {
      method: "POST",
      headers: { "content-type": "application/x-www-form-urlencoded" },
      body: windFieldQuery(spec.box, spec.nx, spec.ny),
    });
    if (!res.ok) return null;
    return windFieldFromOpenMeteo(await res.json(), spec.box, spec.nx, spec.ny);
  } catch {
    return null;
  }
}
